import React from 'react';
import { FileText, Workflow, BarChart3, MessageSquare, Brain, Shield } from 'lucide-react';

// Updated company services data with input/output labels and removed shadowColor
const SERVICES = [
    {
        icon: <FileText className="w-10 h-10 text-blue-500" />,
        title: "Business Solutions",
        description: "Strategic data-driven solutions that transform your business operations and deliver measurable competitive advantage.",
        id: "business-solutions",
        color: "from-blue-400 to-blue-600",
        path: "/business-solutions",
        inputLabel: "Business Challenges",
        outputLabel: "Strategic Advantage"
    },
    {
        icon: <Workflow className="w-10 h-10 text-green-500" />,
        title: "Automation",
        description: "Streamline operations with intelligent automation that reduces manual tasks and increases efficiency across your organization.",
        id: "automation",
        color: "from-green-400 to-green-600",
        path: "/automation",
        inputLabel: "Manual Processes",
        outputLabel: "Operational Efficiency"
    },
    {
        icon: <BarChart3 className="w-10 h-10 text-amber-500" />,
        title: "Dashboards",
        description: "Interactive visualization tools that present your key metrics in real-time for better business oversight and decision making.",
        id: "dashboards",
        color: "from-amber-400 to-amber-600",
        path: "/dashboards",
        inputLabel: "Complex Data",
        outputLabel: "Visual Insights"
    },
    {
        icon: <MessageSquare className="w-10 h-10 text-purple-500" />,
        title: "AI Chatbots",
        description: "Intelligent conversational interfaces that enhance customer experience and streamline internal processes.",
        id: "ai-chatbots",
        color: "from-purple-400 to-purple-600",
        path: "/ai-chatbots",
        inputLabel: "Customer Inquiries",
        outputLabel: "Instant Responses"
    },
    {
        icon: <Brain className="w-10 h-10 text-cyan-500" />,
        title: "AI Solutions",
        description: "Cutting-edge artificial intelligence implementations tailored to your specific business challenges and opportunities.",
        id: "ai-solutions",
        color: "from-cyan-400 to-cyan-600",
        path: "/ai-solutions",
        inputLabel: "Domain Expertise",
        outputLabel: "Intelligent Systems"
    },
    {
        icon: <Shield className="w-10 h-10 text-red-500" />,
        title: "Security",
        description: "Robust protection for your valuable data assets with comprehensive security protocols and proactive monitoring.",
        id: "security",
        color: "from-red-400 to-red-600",
        path: "/security",
        inputLabel: "Vulnerability Exposure",
        outputLabel: "Protected Assets"
    }
];

export default SERVICES;